import { assign } from 'core-js/fn/object';
import * as React from 'react';
import * as CONST from '../../../helpers/const';

const InlineInput = props => {
  let inputColStyle = {
    display: "flex"
  };
  let inputStyle = {};
  if (props.indicateMaxLength) {
    if (props.maxLength.length == 3) {
      inputColStyle.paddingRight = "8px";
    } else if (props.maxLength.length >= 4) {
      inputColStyle.paddingRight = "0px";
    }
  }
  if (CONST.InputTYPE.LABEL == props.containerType) {
    inputColStyle.paddingTop = "8px";
    inputStyle.width = "100%";
  }
  if (props.aza) {
    inputStyle.paddingLeft = "53px";
  }
  if (CONST.InputTYPE.NUMBER == props.type) {
    if(props.numberAlignRight != false) {
      inputStyle.textAlign = "right";
    }
  }
  if (props.inputStyle3 != undefined) {
    inputColStyle = props.inputStyle3;
  }
  if(props.textAreaHeight != null) {
    inputStyle.height = props.textAreaHeight;
  }
  if(props.isBold != null && props.isBold == true) {
    inputStyle.fontWeight = "bold";
  }
  if(props.inputColStyle != null) {
    inputColStyle = {...inputColStyle, ...props.inputColStyle};
  }
  return (
    <div className={props.noformgroup?"":(null != props && props.orientation != CONST.OrientationX ? "row" : (props.columnSize != null ? props.columnSize : "")) + " form-group"} style={props.divStyle}>
      <div className={null != props.labelColName || undefined != props.labelColName ? props.labelColName : "col-md-4 col-sm-4 input-group-text"} style={props.labelDivStyle}>
        <label className="control-label" htmlFor={props.name}
          style={props.isLabelWithBr ? { textAlign: 'left', whiteSpace: 'normal' } : undefined}>
            {props.label}
          </label>
      </div>
      <div className={null != props.inputColName || undefined != props.inputColName ? props.inputColName : "col-md-8 col-sm-8"} style={inputColStyle}>
        {
          CONST.InputTYPE.LABEL == props.containerType ?
            <label className="control-label" style={inputStyle} htmlFor={props.name}>{props.type == CONST.InputTYPE.NUMBER ? props.value.toLocaleString('en') : props.value}</label>
            : CONST.InputTYPE.TEXTAREA == props.containerType ?
              <textarea readOnly={props.readOnly} style={inputStyle} autoComplete="off" className="form-control" maxLength={props.maxLength} disabled={props.disabled} name={props.name} placeholder={props.placeholder} value={props.value} onChange={e => props.onChange(e.target.value)} ></textarea>
              : <input readOnly={props.readOnly} type={props.type != null ? props.type : "text"} style={inputStyle} disabled={props.disabled} maxLength={props.maxLength} autoComplete="off" className="form-control" name={props.name} placeholder={props.placeholder} value={props.value} onChange={e => props.onChange(e.target.value)} min={props.min} />

        }
        {
          props.indicateMaxLength ?
            props.custom1 == true ?
              <div style={{ paddingLeft: "2px", whiteSpace: "nowrap", paddingTop: "7px" }}>{`${props.customMaxLength}`}</div>
              :
              <div style={{ paddingLeft: "2px", color: "red" }}>{`(${props.maxLength})`}</div>
            : null
        }
      </div>
    </div>
  );
}

export default InlineInput;


// WEBPACK FOOTER //
// ./components/forms/inlineinput/index.jsx